import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import appStore from '@/stores/app.store'
import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import VueGtm from '@gtm-support/vue-gtm'
import vfmPlugin from 'vue-final-modal'
import FloatingVue from 'floating-vue'

import './../node_modules/floating-vue/dist/style.css'
import './../node_modules/vue-multiselect/dist/vue-multiselect.css'
import './../node_modules/flatpickr/dist/flatpickr.min.css'
import './../node_modules/@vueform/slider/themes/default.css'
import './assets/styles/index.css'

import 'virtual:svg-icons-register'

// @ts-ignore
import VueResizeObserver from 'vue-resize-observer'
import activateDatadog from '@/services/datadog.service'
import GoogleTagManagerService from '@/services/google-tag-manager.service'
import i18n from '@/services/i18n.service'

const app = createApp(App)

app.use(router)
app.use(i18n)
// @ts-ignore
app.use(vfmPlugin)
app.use(VueResizeObserver)

// FloatingVue Settings (tooltips, popovers, ...)
FloatingVue.options.themes.tooltip.html = true

app.use(FloatingVue)

if (import.meta.env.VITE_MODE !== 'local') {
  activateDatadog()
  app.use(VueGtm, GoogleTagManagerService.getVueGtmOptions())
}

app.config.globalProperties.$filters = {
  formattedDate(dateString: string): string {
    const date = new Date(dateString)
    return date.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  },
}

app.mount('#app')
